import { campaignsT as t } from '@cyberint/common-campaigns';
import {
  CampaignNameCell,
  CountriesCell,
  DateCell,
  MalwareCell,
  SectorsCell,
  ThreatActorsCell
} from './components/Cells';

export const campaignsColumnsKeys = {
  CAMPAIGN_NAME: 'name',
  DISCOVERY_DATE: 'first_seen',
  ATTRIBUTION: 'threat_actors',
  MALWARE: 'malwares',
  SECTORS: 'sector',
  COUNTRY: 'country'
};

const { CAMPAIGN_NAME, DISCOVERY_DATE, ATTRIBUTION, MALWARE, SECTORS, COUNTRY } = campaignsColumnsKeys;

export const campaignsColumnsConfig = {
  [CAMPAIGN_NAME]: {
    header: t('table.campaignName'),
    accessorKey: CAMPAIGN_NAME,
    id: CAMPAIGN_NAME,
    enableSorting: true,
    size: 200,
    Cell: CampaignNameCell
  },
  [DISCOVERY_DATE]: {
    header: t('table.discoveryDate'),
    accessorKey: DISCOVERY_DATE,
    id: DISCOVERY_DATE,
    enableSorting: true,
    size: 100,
    Cell: DateCell
  },
  [ATTRIBUTION]: {
    header: t('table.attribution'),
    accessorKey: ATTRIBUTION,
    id: ATTRIBUTION,
    enableSorting: false,
    size: 250,
    Cell: ThreatActorsCell
  },
  [MALWARE]: {
    header: t('table.malware'),
    accessorKey: MALWARE,
    id: MALWARE,
    enableSorting: false,
    size: 250,
    Cell: MalwareCell
  },
  [SECTORS]: {
    header: t('table.sectors'),
    accessorKey: SECTORS,
    id: SECTORS,
    enableSorting: false,
    size: 200,
    Cell: SectorsCell
  },
  [COUNTRY]: {
    header: t('table.countries'),
    accessorKey: COUNTRY,
    id: COUNTRY,
    enableSorting: false,
    size: 200,
    Cell: CountriesCell
  }
};
